import { useId } from 'react';

import styles from './GradebookLoadingBar.module.css';

interface GradebookLoadingBarProps {
  loaded: number;
  total: number;
}

export function GradebookLoadingBar({
  loaded,
  total,
}: GradebookLoadingBarProps) {
  const labelId = useId();
  const percent = total > 0 ? Math.round((loaded / total) * 100) : 100;

  return (
    <section
      aria-label="Grade loading progress"
      className={styles.container}
    >
      <div className={styles.header}>
        <p className={styles.label} id={labelId}>
          Loading grades
        </p>
        <p aria-live="polite" className={styles.value} role="status">
          {loaded}/{total} students
        </p>
      </div>
      <div
        aria-labelledby={labelId}
        aria-valuemax={100}
        aria-valuemin={0}
        aria-valuenow={percent}
        className={styles.track}
        role="progressbar"
      >
        <div className={styles.fill} style={{ width: `${percent}%` }} />
      </div>
    </section>
  );
}
